import { SOCIAL_LINKS } from '@lib/constants';

const Social = () => {
  const socialLinks = SOCIAL_LINKS.map((item) => (
    <a
      key={item.href}
      href={item.href}
      className="text-neutral-50 hover:text-neutral-200"
    >
      <span className="sr-only">{item.title}</span>
      <svg
        className="w-6 h-6"
        fill="currentColor"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <path fillRule="evenodd" d={item.pathDrawn} clipRule="evenodd" />
      </svg>
    </a>
  ));
  return <>{socialLinks}</>;
};

export default Social;
